// Port of api/fuel/app/classes/filter/search/games/filters/query/game/count/recommended.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'game.count.recommended',
	priority: 47,
	require: function(config, filter) {
		return rangeActive(filter.count && filter.count.recommended, 1, 10)
	},
	run: function(config, filter, data, query) {
		query.select('g.game_players_community', 'pc')
	}
}
